import {
  ReadClientTypesForAssignToUserResponseDto,
  ReadClientTypesForAssignToUserRequestDto,
  ReadClientTypesRequestDto,
  ReadClientTypesResponseDto,
  GetClientTypeDetailsResponseDto,
  CreateClientTypeRequestDto,
  CreateClientTypeResponseDto,
  UpdateClientTypeRequestDto,
  UpdateClientTypeResponseDto,
  GetListOfClientTypesResponseDto,
} from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'

export const fetchListOfClientTypes = async (
  { token }: { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetListOfClientTypesResponseDto[]> => {
  const response = await axios.get<GetListOfClientTypesResponseDto[]>(
    `${process.env.REACT_APP_SERVER_URL}/crm/client-types/list-of-client-types`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const fetchClientTypesForAssignToUser = async (
  { token, ...params }: ReadClientTypesForAssignToUserRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadClientTypesForAssignToUserResponseDto> => {
  const response = await axios.get<ReadClientTypesForAssignToUserResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/client-types/client-types-for-assign-to-user`,
    {
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const fetchClientTypes = async (
  { token, ...params }: ReadClientTypesRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadClientTypesResponseDto> => {
  const response = await axios.get<ReadClientTypesResponseDto>(`${process.env.REACT_APP_SERVER_URL}/crm/client-types`, {
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const fetchClientTypeDetails = async (
  { token, id }: { id: string } & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetClientTypeDetailsResponseDto> => {
  const response = await axios.get<GetClientTypeDetailsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/client-types/${id}/details`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const createClientType = async (
  { token, ...data }: CreateClientTypeRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateClientTypeResponseDto> => {
  const response = await axios.post<CreateClientTypeResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/client-types/create`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateClientType = async (
  { token, id, ...data }: { id: string } & UpdateClientTypeRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateClientTypeResponseDto> => {
  const response = await axios.post<UpdateClientTypeResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/client-types/${id}/update`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
